var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frameworks__Type=Frameworks, State=Enabled",
    className: "frameworks__Type=Frameworks, frameworks__State=Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frameworks__Vector",
    className: "frameworks__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454F5B",
    d: "M2.486 20.887V5.52a2.24 2.24 0 0 1 2.24-2.24h1.943a.747.747 0 0 1 0 1.493H4.726a.746.746 0 0 0-.747.747v15.367c0 .412.335.746.747.746h14.548a.747.747 0 0 0 .747-.746V5.52a.747.747 0 0 0-.747-.747h-1.698a.747.747 0 0 1 0-1.493h1.698a2.24 2.24 0 0 1 2.24 2.24v15.367a2.24 2.24 0 0 1-2.24 2.239H4.726a2.24 2.24 0 0 1-2.24-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454F5B",
    d: "M14.47 3.365a.746.746 0 0 0-.746-.746h-3.45a.746.746 0 0 0-.746.746v.614c0 .412.335.747.747.747h3.45a.747.747 0 0 0 .746-.746v-.615Zm1.494.615a2.24 2.24 0 0 1-2.24 2.24h-3.45a2.24 2.24 0 0 1-2.239-2.241v-.614a2.24 2.24 0 0 1 2.24-2.239h3.45a2.24 2.24 0 0 1 2.239 2.24v.614Zm-.894 6.01a.75.75 0 1 1 1.094 1.025l-4.911 5.247a.75.75 0 0 1-1.089.006l-2.321-2.42a.75.75 0 0 1 1.084-1.039l1.771 1.85 4.371-4.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update_icon.551552de196c0dec8cc9c003e56c0156.svg";
export { ForwardRef as ReactComponent };